import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { DateRangePicker } from 'react-bootstrap-daterangepicker';
import { connect } from 'react-redux';
import { Button, CardBody, Col, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';
import swal from "sweetalert";
import { promocodeActions } from '../../actions';
import { InputText } from '../Settings/StageSetting/Components/FormElements';


const initialData = {
    type: 'fixed',
    code: '',
    description: '',
    usable_count: '',
    discount: '',
    is_recharge: 0,
    is_registration: 1,
    extra_balance: '',
    is_public: 0,
    is_default: 0
}

function PromoCodeData(props) {
    const [show, setShow] = useState(false)
    const [formData, setFormData] = useState({
        ...initialData
    })
    const [errors, setErrors] = useState({})
    const [dateData, setDateData] = useState({
        startDate: moment(),
        endDate: moment(),
        serachField: {
            dateRange: moment().format("DD MMM Y") + "-" + moment().add(1, 'day').format("DD MMM Y")
        }
    })


    const toggle = () => {
        setShow(!show)
    }

    const handleClick = (value) => {
        if (value === 'is_default') {
            formData.is_default = formData.is_default ? 0 : 1
        }

        if (value === 'is_public') {
            formData.is_public = formData.is_public ? 0 : 1
        }
        if (value === 'is_recharge') {
            formData.is_recharge = formData.is_recharge ? 0 : 1
            errors.is_registration = ''
        }
        if (value === 'is_registration') {
            formData.is_registration = formData.is_registration ? 0 : 1
            errors.is_registration = ''
        }
        if (value === 'fixed' || value === 'percentage') {
            formData.type = value
            formData.discount = ""
            errors.discount = ''
        }


        setFormData({ ...formData })
        setErrors({ ...errors })
    }

    const handleChange = (e) => {
        const { name, value } = e.target
        let _value = value

        if (name == 'code') {
            _value = _value.toUpperCase()
        }

        if ((name === 'usable_count' || name === 'extra_balance' || name === 'discount') && _value) {
            _value = Number(_value)
            if (isNaN(_value) || formData.type === 'percentage' && (_value > 100 || _value < 0)) {
                return false
            }

            if (formData.type === 'fixed' && _value > 999) {
                return false
            }
        }

        if (name == 'extra_balance') {
            errors['discount'] = "";
        }
        setFormData({ ...formData, [name]: _value })
        setErrors({ ...errors, [name]: '' })
    }

    const save = () => {
        const { dispatch } = props
        const { startDate, endDate } = dateData
        if (!valid()) {
            let dataToSend = {
                ...formData,
                start_date: moment(startDate).format('YYYY/MM/DD'),
                expiry_date: moment(endDate).format('YYYY/MM//DD')
            }
            dispatch(promocodeActions.savePromocode(dataToSend, {
                success: afterSave
            }))
        }
    }

    const afterSave = () => {
        reset()
        getData()
        toggle()
    }

    const reset = () => {
        setFormData({ ...initialData })
        setErrors({})
    }

    const valid = () => {
        const { type, code, description, usable_count, extra_balance, discount, is_registration, is_recharge } = formData
        const { startDate, endDate } = dateData
        let error = false
        setErrors({});

        if (!code) {
            errors.code = 'Please enter Promo Code'
            error = true
        }
        if (!description) {
            errors.description = 'Please enter description'
            error = true
        }
        if (!usable_count) {
            errors.usable_count = 'Please enter Usable Count '
            error = true
        }
        if (!startDate && !endDate) {
            errors.expiry_date = 'Please select date range  '
            error = true
        }

        if (!discount && !extra_balance) {
            errors.discount = 'Please enter discount / extra balance'
            error = true
        }
        if (!is_registration && !is_recharge) {
            errors.is_registration = 'Select atleast one'
            error = true
        }

        setErrors({
            ...errors
        })
        return error

    }

    useEffect(() => {
        getData()
    }, []);

    const getData = () => {
        const { dispatch } = props
        dispatch(promocodeActions.getPromocodes())
    }

    const handleDelete = (id, code) => {
        const { dispatch } = props

        let dataToSend = { id: id }

        swal({
            title: "Are you sure ?",
            text: `Do you want to delete ${code} coupen code ?`,
            icon: "warning",
            buttons: true,
            dangerMode: true,
            buttons: ["Cancel", "Yes, I am sure!"],
        }).then((confirm) => {
            if (confirm) {
                dispatch(promocodeActions.deletePromocode(dataToSend, {
                    success: getData
                }))
            }
        })

    }

    const handleEdit = (data, type) => {

        const { dispatch } = props
        let dataToSend = {
            id: data.id,
            [type]: data[type] === 0 ? 1 : 0
        }
        dispatch(promocodeActions.editPromoCode(dataToSend, {
            success: getData
        }))


    }


    const handleEvent = (event, picker) => {
        var start = picker.startDate.format("DD MMM Y");
        var end = picker.endDate.format("DD MMM Y");
        let label = start + ' to ' + end;
        if (start === end) {
            label = start;
        }
        setDateData({
            ...dateData,
            startDate: picker.startDate,
            endDate: picker.endDate,
            serachField: {
                dateRange: label
            },
        })
    }


    const { startDate, endDate, ranges, serachField } = dateData

    return (
        <React.Fragment>
            <Row>
                <Col xs="12">
                   
                        <CardBody>
                             <span className='pull-right' ><Button size='sm' color='primary' onClick={toggle} > + Add Promocode</Button> </span>

                            <div className="table-responsive-sm mt-5">
                                <table className="table table-hover  ">
                                    <thead>
                                        <tr >
                                            <th>No</th>
                                            <th>Code</th>
                                            <th>Is Public</th>
                                            <th className='text-center' >Default</th>
                                            <th>Usage</th>
                                            <th>Usable</th>
                                            <th>Discount</th>
                                            <th>Extra Balance</th>
                                            <th>For Registration</th>
                                            <th>For Recharge</th>
                                            <th>Start At </th>
                                            <th>Expires At </th>
                                            <th>Status</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>

                                        {
                                            props.data && props.data.length ? props.data.map((eachData, index) => {
                                                return (
                                                    <tr>
                                                        <td>{index + 1}</td>
                                                        <td title={eachData.description} >{eachData.code}</td>
                                                        <td className='d-flex' >
                                                            <input className=' d-block ' type="checkbox" checked={eachData.is_public} onClick={() => handleEdit(eachData, 'is_public')} />
                                                            <span className={`mx-2 badge ${eachData.is_public ? 'bg-success' : 'bg-danger'}`} >{eachData.is_public ? 'public' : 'private'}</span>
                                                        </td>
                                                        <td><input className='mx-auto d-block ' type="checkbox" checked={eachData.is_default} onClick={() => handleEdit(eachData, 'is_default')} /></td>
                                                        <td>{eachData.usage_count ? eachData.usage_count : 0}</td>
                                                        <td>{eachData.usable_count}</td>
                                                        <td>{eachData.type === 1 ? `₹ ${eachData.discount}` : `${eachData.discount} % `}</td>
                                                        <td>{eachData.extra_balance ? `₹ ${eachData.extra_balance}` : 0}</td>
                                                        <td><input className='mx-auto d-block ' type="checkbox" checked={eachData.is_registration} onClick={() => handleEdit(eachData, 'is_registration')} /></td>
                                                        <td><input className='mx-auto d-block ' type="checkbox" checked={eachData.is_recharge} onClick={() => handleEdit(eachData, 'is_recharge')} /></td>
                                                        <td>{eachData.start_date}</td>
                                                        <td>{eachData.expiry_date}</td>
                                                        <td className='d-flex' >
                                                            <input className=' d-block ' type="checkbox" checked={eachData.status} onClick={() => handleEdit(eachData, 'status')} />
                                                            <span className={`mx-2 badge ${eachData.status ? 'bg-success' : 'bg-danger'}`} >{eachData.status ? 'Active' : 'Inactive'}</span>
                                                        </td>
                                                        <td> <span className='cursor-pointer' onClick={() => handleDelete(eachData.id, eachData.code)} > <i className="fa fa-trash-o text-danger font-xl"></i> </span> </td>
                                                    </tr>
                                                )
                                            })
                                                :
                                                <tr>
                                                    <td colSpan={11} className='text-center' >No Data Found </td>
                                                </tr>
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </CardBody>
                   
                </Col>
            </Row>
            <Modal
                size='md'
                isOpen={show}
                toggle={toggle}
            >
                <ModalHeader
                    toggle={toggle} >
                    Add New Promocode
                </ModalHeader>
                <ModalBody>


                    <div className='d-flex justify-content-between'  >
                        <span className='w-50  px-2' >
                            <InputText
                                isRequired
                                error={errors.code}
                                title={'Promo Code'}
                                placeholder="Promo Code"
                                value={formData.code}
                                name="code"
                                onChange={handleChange}
                                maxLength="250"
                            />
                        </span>
                        <span className='w-50  px-2' >
                            <InputText
                                isRequired
                                error={errors.description}
                                title={"Description"}
                                placeholder="Description"
                                value={formData.description}
                                name="description"
                                onChange={handleChange}
                                maxLength="250"
                            />
                        </span>
                    </div>
                    <div className='d-flex justify-content-between' >

                        <span className='w-50  px-2' >
                            <div className='mb-2' >Select Range<span className='text-danger' >*</span> </div>
                            <DateRangePicker
                                startDate={startDate}
                                endDate={endDate}
                                onEvent={handleEvent}

                            >
                                <div className="input-group">
                                    <input type="text" className="form-control" value={serachField.dateRange} placeholder="Select Date Range" id="date_picker" style={{ 'width': '220px' }} onClick={e => e.preventDefault()} />

                                </div>
                            </DateRangePicker>

                        </span>

                        <span className='w-50 px-2' >
                            <InputText
                                isRequired
                                error={errors.usable_count}
                                title={"Usable"}
                                placeholder="Usable"
                                value={formData.usable_count}
                                name="usable_count"
                                onChange={handleChange}
                                maxLength="250"
                            />
                        </span>
                    </div>
                    <div className='d-flex my-3 px-2 ' >
                        <input type="radio" id="fixed" className='mr-2' checked={formData.type === 'fixed'} onClick={() => handleClick('fixed')} />
                        <label htmlFor="fixed" className='my-auto mr-5'>Flat Discount</label>
                        <input type="radio" id="Discount" className='mr-2' checked={formData.type === 'percentage'} onClick={() => handleClick('percentage')} />
                        <label htmlFor="Discount" className='my-auto'>% Discount</label>
                    </div>

                    <div className='d-flex justify-content-between' >
                        <span className='w-50  px-2' >
                            <InputText
                                // isRequired`  `
                                error={errors.discount}
                                title={`${formData.type === 'fixed' ? "Flat Discount" : 'Discount'}`}
                                placeholder={`${formData.type === 'fixed' ? "Flat Discount" : 'Discount'}`}
                                value={formData.discount}
                                name="discount"
                                onChange={handleChange}
                                maxLength="250"
                            />
                        </span>
                        <span className='w-50  px-2' >
                            <InputText
                                error={errors.extra_balance}
                                title={"Extra Balance"}
                                placeholder="Extra Balance"
                                value={formData.extra_balance}
                                name="extra_balance"
                                onChange={handleChange}
                                maxLength="250"
                            />
                        </span>
                    </div>
                    <div style={{ display: 'flex', flexDirection: "column" }} >
                        <div >
                            <input
                                type='checkbox'
                                checked={formData.is_registration}
                                name="is_registration"
                                id="is_registration"
                                onChange={() => handleClick('is_registration')}
                            />
                            <label htmlFor="is_registration" >&nbsp; For Registration / New Company</label>
                        </div>
                        <div  >
                            <input
                                type='checkbox'
                                checked={formData.is_recharge}
                                name="is_recharge"
                                id="is_recharge"
                                onChange={() => handleClick('is_recharge')}
                            />
                            <label htmlFor="is_recharge"> &nbsp; For Recharge</label>
                        </div>
                        <div  >
                            <input
                                type='checkbox'
                                checked={formData.is_default}
                                name="is_default"
                                id="is_default"
                                onChange={() => handleClick('is_default')}
                            />
                            <label htmlFor="is_default"  > &nbsp; Default Coupen </label>
                        </div>

                        <div  >
                            <input
                                type='checkbox'
                                checked={formData.is_public}
                                name="is_public"
                                id="is_public"
                                onChange={() => handleClick('is_public')}
                            />
                            <label htmlFor="is_public">&nbsp; Public Coupen</label>
                        </div>
                    </div>

                </ModalBody>

                <ModalFooter>
                    <Button color="primary" onClick={save}>
                        Save
                    </Button>{" "}
                    <Button color="info" onClick={reset}>
                        Reset
                    </Button>{" "}
                    <Button color="secondary" onClick={toggle}>
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>



        </React.Fragment>

    )
}



function mapStateToProps(state) {
    const { loading, data } = state.getPromocodes
    return { loading, data }
}

// const connectedPromoCodeData = connect(mapStateToProps)(PromoCodeData);
const connectedPromoCodeData = connect(mapStateToProps)(PromoCodeData);
export default connectedPromoCodeData;

